import React from "react";
import styles from "./PAIStatements.module.scss";
import {  PAI_LINKS, } from "../../constants/links";
import BlackHeader from "../Layout/BlackHeader/BlackHeader";
import MetaDecorator from "../Util/MetaDecorator";
import Footer from "../Layout/Footer/Footer";

const PoliciesAndDisclosures = () => {
	return (
		<>
			<div className="sticky-header">
				<BlackHeader />
			</div>
			<MetaDecorator
				title={"PAI Statement | LRC Group"}
				description={
					"Statement on principal adverse impacts of investment decisions on sustainability factors"
				}
			/>
			<div className="long-container">
				<div className={styles.page}>
					{/* <h1>Policies and disclosures</h1> */}
					<ul>
						{PAI_LINKS.map((item) => (
							<li key={item.href}>
								<span>-</span>
								<a
									href={item.href}
									target="_blank">
									{item.title}
								</a>
							</li>
						))}
					</ul>
				</div>
			</div>
			<>
				<Footer />
			</>
		</>
	);
};

export default PoliciesAndDisclosures;
